import React, { Component }  from 'react';
import InternalService from '../../services/internal-api';
import ReferenceBand from './reference-band/reference-band';
import PersonCarousel from './carousel/PersonCarousel';

import './intro.css';

export default class Intro extends Component {

  data = new InternalService();

  state = {
    dukesList: null,
    twenties: null,
    saintsFrequency: null,
    selectedRange: "961"
  };

  componentDidMount() {
    let searchParam = this.props.match ? this.props.match.params["br"] : null;
    this.data.getDukes([searchParam])
        .then((body) => {
          this.setState({
            dukesList: body.data || []
          });
        });
    this.data.getDensity()
        .then((body) => {
          this.setState({
            twenties: body.data
          });
        }); 
    this.data.getIconography()
        .then((body) => {
          this.setState({
            saintsFrequency: body.data
          });
        });    
  }

  handleRangeChange = (lowerDate) => {
    this.setState({ selectedRange: lowerDate }, () => {
      this.data.getDukes([null, lowerDate]).then((body) => {
        this.setState({
          dukesList: body.data,
        });
      });
    });
  };

  renderItems(arr, branch) {
    let firstCN = ``;
    let secondCN = ``;
    let counter = 0;
    const columns = this.props.match ? (arr.length+1)%3 : arr.length%3;
    switch(columns) {
      case 1:
        firstCN =`first-1uneven`;
        secondCN = `third`;
        break;
      case 2:
        firstCN =`first-2uneven`;
        secondCN = `third`;
        break;
      default:
    }

    return arr.map(({
        id,
        name,
        name_en,
        dateBirth,
        dateDeath,
        datePower,
        birthProximity,
        powerProximity,
        deathProximity,
        idBranch,
        idHusband,
        pic, ext
      }) => {

      const birth = dateBirth ? `${birthProximity?'≈':''}${dateBirth} ` : '';
      const power = datePower ? `ϡ ${powerProximity?'≈':''}${datePower} ` : '';
      const death = dateDeath ? `† ${deathProximity?'≈':''}${dateDeath}` : '';
      const dates = `${birth}${power}${death}`;
      const title = `${name_en} (${dates})`;
      function link() {window.location.href=`/person/${id}`};
      const uniqueKey = `duke${id}`;
      let className = `box `;

      let sectionStyle = {};
      if (pic)
        sectionStyle = {
          backgroundImage: branch ? `url('${this.data._apiBase}illustrations/${pic}.${ext}')` : '',
          backgroundSize: `cover`,
          textShadow: `2px 2px black`
        };

      const specialGroup = ([7, 8].includes(idBranch)) ? <img className='imageShade' height='50' src='./../../../icons/priest.png' /> : 
        idHusband ? <img className='imageShade' height='50' src='./../../../icons/princess.png' /> : null  ;  

      counter++;
      switch(counter) {
        case 1:
          className += firstCN; 
          break;
        case 2:
          className += secondCN;
          break;
        default:
      }
      return (
          <div key={uniqueKey} className={className} style={sectionStyle} onClick={link}>
                {title}
                <div className='iconGroup'>{specialGroup}</div>
          </div>
      );
    });
  }
 
  render() {
    const { dukesList, twenties, saintsFrequency, selectedRange } = this.state;

    const styleAll = {
      backgroundImage: `url('${this.data._apiBase}illustrations/0.jpeg')`,
      backgroundSize: `cover`,
      textShadow: `2px 2px black`
    };
    
    const seeAll = this.props.match ? (
      <div key="seeAll" style = {styleAll} className='box box-all' onClick={()=>window.location.href=`/`}>
        See dukes of different branches
      </div>) : null;

    if (!dukesList || dukesList.length === 0) {
      return seeAll
    }

    const picturedDukes = dukesList
      .filter(item => item.pic != null)
      .map(item => ({
        link: `/person/${item.id}`,
        image: `${this.data._apiBase}illustrations/${item.pic}.${item.ext}`,
        type: 'person',
        title: item.name_en
      }));

    const picturedSaints = saintsFrequency ? saintsFrequency
      .filter(item => item.random_image_id != null)
      .map(item => ({
        link: `/saint/${item.saint_id}`,
        image: `${this.data._apiBase}saint_images/${item.random_image_id}.jpg`,
        type: 'saint',
        title: item.saint
      })) : [];

      console.log(dukesList)

    function shuffleArray(array) {
      const result = [...array];
      for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
      }
      return result;
    }
    const merged = shuffleArray([...picturedDukes, ...picturedSaints]);

    const branch = this.props.match ? 
      (<div className="padding-both wrapper grid-container">{dukesList[0].branch}</div>) : null;
    const items = this.renderItems(dukesList.slice(0, 24), branch);

    const timeline = twenties && twenties.length > 0 ? (
      <div style={{ overflowX: "auto", padding: "20px", position: 'relative' }}>
        <div
          style={{
            position: "absolute",
            top: "100px",
            left: "50px",
            color: "#00bc8c",
            whiteSpace: "nowrap", 
          }}
        >
          Attributed types <br/> over years
        </div>
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
              {Object.keys(twenties[0]).map((period) => {
                const [lowerDate] = period.split("-"); // Extract the lower date of the range
                const isSelected = selectedRange === lowerDate; // Check if this period is selected
                const isBeforeSelected = parseInt(lowerDate) <= parseInt(selectedRange); // Check if this is before or equal to the selected range
    
                return (
                  <th
                    key={period}
                    style={{
                      paddingTop: "5px",
                      textAlign: "center",
                      background: isSelected
                        ? "linear-gradient(to right, #00bc8c, transparent)" // Selected range with gradient
                        : isBeforeSelected
                        ? "#00bc8c" // Solid green for previous ranges
                        : "transparent", // Transparent for future ranges
                      color: isBeforeSelected ? "white" : "inherit",
                      cursor: "pointer",
                      transition: isSelected ? "background-size 0.5s ease-in-out" : "none", // Smooth transition for the selected range
                    }}
                    onClick={() => this.handleRangeChange(lowerDate)}
                  >
                    <label
                      style={{
                        display: "block",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="dateRange"
                        value={lowerDate}
                        checked={isSelected}
                        onChange={() => this.handleRangeChange(lowerDate)}
                        style={{ display: "none" }} // Hide the radio button itself
                      />
                      {period.split('-')[1]-10}
                    </label>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              {Object.entries(twenties[0]).map(([period, count]) => (
                <td
                  key={period}
                  style={{
                    textAlign: "center",
                    verticalAlign: "bottom",
                  }}
                >
                  {/* Count above the bar */}
                  <div style={{ position: "relative", height: "150px" }}>

                    {/* Full width color bar */}
                    <div
                      style={{
                        backgroundColor: "#00bc8c",
                        width: "100%",
                        height: `${count*0.8}px`, 
                        position: "absolute",
                        bottom: "0", 
                      }}
                    ></div>
                      <div
                      style={{
                        position: "absolute",
                        bottom: "10px", 
                        left: "50%",
                        transform: "translateX(-50%)",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#444",
                      }}
                    >
                      {count}
                    </div>
                  </div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    ) : null;   

    const mainstreamType = (
      <div className="custom-layout-container">
        <div className="custom-layout-row">
          <div style={{ gridColumn: 'span 4' }}></div>
          <div className="custom-layout-text" style={{ gridColumn: 'span 9', height: '100%', marginRight: '2px' }}><a style={{ color: 'white' }} href="/search/letters/1001/saints/null">K[υρι]ε βοηθει</a></div>
          <div className="custom-layout-text" style={{ gridColumn: 'span 2', height: '100%', marginRight: '2px' }}><a style={{ color: 'white' }} href="/search/letters/1002/saints/null">ДЬNѢСЛОВО</a></div>
          <div className="custom-layout-text" style={{ gridColumn: 'span 3', height: '100%', marginRight: '2px' }}><a style={{ color: 'white' }} href="/search/letters/1003/saints/null">Гн Помозн</a></div>
          <div className="custom-layout-images" style={{ gridColumn: 'span 10' }}>
            <a href="/search/saints/null/saints/null">
              <img src="assets/1-1.svg" alt="1-1" style={{ height: '50px' }} />
              <img src="assets/1-2.svg" alt="1-2" style={{ height: '50px' }} />
            </a>
          </div>
        </div>
        <div className="custom-layout-row" >
          <div className="custom-layout-images" style={{ gridColumn: 'span 12' }}>
            <a href="/search/saints/null/other/1">
              <img src="assets/2-1.svg" alt="2-1" style={{ height: '50px' }} />
              <img src="assets/2-2.svg" alt="2-2" style={{ height: '50px' }} />
            </a>
          </div>
          <div style={{ gridColumn: 'span 6' }}></div>
          <div className="custom-layout-images" style={{ gridColumn: 'span 2' }}>
            <a href="/search/signs/null/saints/null">
              <img src="assets/2-3.svg" alt="2-3" style={{ height: '50px' }} />
            </a>
          </div>
          <div style={{ gridColumn: 'span 8' }}></div>
        </div>
        <div className="custom-layout-row" >
          <div style={{ gridColumn: 'span 10', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#00bc8c' }}>Mainstream types</div>
          <div className="custom-layout-images" style={{ gridColumn: 'span 7' }}>
            <a href="/search/saints/null/crosses/null">
              <img src="assets/2-1.svg" alt="3-1" style={{ height: '50px' }} />
              <img src="assets/3.svg" alt="3-2" style={{ height: '50px' }} />
            </a>
          </div>
          <div style={{ gridColumn: 'span 11' }}></div>
        </div>
      </div>
    );       
      
    return (
      <div className="bottom"> 
        <ReferenceBand />
        {!branch && <PersonCarousel items={merged} />}
        {!branch && timeline}
        {!branch && mainstreamType}
        {branch}
        <div className="padding-both wrapper grid-container">
          {items}
          {seeAll}
        </div>
      </div>
    )
  }
}